import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import InventoryServices from "../../services/InventoryServices";
import CottageServices from "../../services/CottageServices";
import Pagetitle from "../../component/PageTitle";

function AddRoom() {
  const navigate = useNavigate();
  const [cottage, setCottage] = useState([]);
  const [formValues, setFormValues] = useState({
    cottage: "",
    roomNumber: "",
    roomType: null, // Initialize as null instead of an empty string
    description: "",
    status: "",
  });

  const [previewImage, setPreviewImage] = useState("img/placeholder-img.png");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  useEffect(() => {
    const fetchCottage = async () => {
      try {
        const res = await CottageServices.getCottage();
        if (res.status) {
          setCottage(res.data);
        } else {
          alert('Failed to fetch Cottage');
        }
      } catch (error) {
        console.error('Error fetching Cottage', error);
        alert('Failed to fetch Cottage');
      }
    };
    fetchCottage();
  }, []);



  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        // Check if the value is not null or undefined
        if (formValues[key] !== null && formValues[key] !== undefined) {
          formData.append(key, formValues[key]);
        }
      }

      const response = await InventoryServices.createInventory(formValues);

      alert("Inventory Added Successfully");
      navigate("/inventory-list");
    } catch (error) {
      console.error("Failed to add Inventory", error);
      alert(error.response.data.message || 'Failed to add Inventory');
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div>
        <form onSubmit={handleSubmit}>
          <div className="container-box">
            <div className="container-box-top-header justify-content-between">
              <h4>Select Cottage</h4>
              <div className="sub-title-box-right">
                <Link className="site-btn-green" to="/inventory-list">
                  Inventory List
                </Link>
              </div>
            </div>
            <div className="container-box-inner px-4">
              <div className="page-details">

                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Select Cottage</label>
                      <select className="form-select" name="cottage" value={formValues.cottage} onChange={handleInputChange}>
                        <option value="">Select  Cottage</option>
                        {cottage.map((cot) => (
                          <option key={cot._id} value={cot._id}>
                            {cot.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="container-box">
            <div className="container-box-top-header justify-content-between">
              <h4>Add Room Details</h4>
            </div>
            <div className="container-box-inner px-4">
              <div className="page-details">

                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Cottage Number</label>
                      <input
                        type="text"
                        name="roomNumber"
                        className="form-control"
                        value={formValues.roomNumber}
                        onChange={handleInputChange}
                        placeholder="Enter Cottage Number"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Room Type</label>
                      <select className="form-select" name="roomType" value={formValues.roomType} onChange={handleInputChange}>
                        <option selected="">Select Room Type</option>
                        <option value="Single">Single</option>
                        <option value="Double">Double</option>
                        <option value="Suite">Suite</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Cottage Status</label>
                      <select className="form-select" name="status" value={formValues.status} onChange={handleInputChange}>
                        <option selected="">Select Room Status</option>
                        <option value="Available">Available</option>
                        <option value="Booked">Booked</option>
                        <option value="Maintenance">Maintenance</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="input-field">
                      <label>Description</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control"
                        value={formValues.description}
                        onChange={handleInputChange}
                        placeholder="Enter  Description"
                        required
                      />
                    </div>
                  </div>
                 
                </div>
                <button className="site-btn-green" type="submit">
                  Save
                </button>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddRoom;
